export const WORDS = [
  'abrau',
  'estao',
  'rixer',
  'remes',
  'rufea',
  'sogas',
  'salts',
  'olost',
  'sorba',
  'aubis',
  'fitor',
  'pleja',
  'espui',
  'marça',
  'rifos',
  'foixa',
  'treja',
  'vedor',
  'salat',
  'rials',
  'horno',
  'riell',
  'laren',
  'sorri',
  'ceuro',
  'civis',
  'pegna',
  'liera',
  'espos',
  'rubio',
  'eller',
  'tremp',
  'obago',
  'forns',
  'naris',
  'pugis',
  'lluça',
  'bleda',
  'sarat',
  'llesp',
  'arreu',
  'llirt',
  'raset',
  'pauli',
  'ampol',
  'sorpe',
  'beuda',
  'borro',
  'comes',
  'nacra',
  'terça',
  'geles',
  'rofes',
  'toiet',
  'roder',
  'timor',
  'mabos',
  'pujol',
  'salom',
  'arati',
  'lavit',
  'gaten',
  'baell',
  'colls',
  'pampa',
  'galit',
  'lleto',
  'jesus',
  'firal',
  'xagas',
  'paris',
  'calaf',
  'noris',
  'burgo',
  'roges',
  'pruit',
  'corça',
  'setut',
  'sants',
  'surri',
  'bussa',
  'erols',
  'niula',
  'ordis',
  'odena',
  'cercs',
  'aleny',
  'rodes',
  'begur',
  'gosol',
  'banat',
  'palol',
  'estac',
  'beret',
  'tueda',
  'benes',
  'roter',
  'cerbi',
  'malda',
  'altet',
  'xerta',
  'mafet',
  'batet',
  'marti',
  'xauxa',
  'viell',
  'sansa',
  'sacli',
  'arres',
  'xeres',
  'soses',
  'cames',
  'torre',
  'moixa',
  'paner',
  'monet',
  'alfou',
  'bords',
  'escos',
  'boiga',
  'barmo',
  'enrou',
  'orden',
  'alfes',
  'donis',
  'gonta',
  'begos',
  'sario',
  'capso',
  'siall',
  'beget',
  'solan',
  'auros',
  'cento',
  'armis',
  'pedro',
  'malus',
  'siern',
  'batea',
  'roses',
  'maset',
  'niort',
  'bitem',
  'orcau',
  'sorts',
  'lilla',
  'ramis',
  'foret',
  'morer',
  'crues',
  'ogern',
  'tomet',
  'femat',
  'bullo',
  'civit',
  'enseu',
  'cugul',
  'rupit',
  'durro',
  'beren',
  'uerri',
  'gorga',
  'flaça',
  'cuilh',
  'benus',
  'manol',
  'paluc',
  'seris',
  'violi',
  'rigat',
  'arros',
  'fique',
  'cauva',
  'felip',
  'osona',
  'closa',
  'rotes',
  'bonos',
  'morat',
  'berta',
  'vello',
  'sorre',
  'mania',
  'sallo',
  'segur',
  'senan',
  'biure',
  'mussa',
  'vilar',
  'badia',
  'orial',
  'corba',
  'ordal',
  'guixo',
  'besso',
  'curan',
  'ramas',
  'riero',
  'aubes',
  'gelat',
  'uries',
  'pimpi',
  'clues',
  'altes',
  'malla',
  'jorba',
  'calic',
  'artes',
  'escas',
  'bodes',
  'tapia',
  'pleto',
  'pedra',
  'malos',
  'naciu',
  'ateus',
  'linse',
  'lluer',
  'falco',
  'garos',
  'silet',
  'llera',
  'vigos',
  'venes',
  'repla',
  'breda',
  'seros',
  'trera',
  'selma',
  'miret',
  'ganix',
  'craup',
  'albio',
  'saput',
  'tonet',
  'palou',
  'riner',
  'rialb',
  'somes',
  'ories',
  'carla',
  'xamal',
  'prado',
  'gaver',
  'tallo',
  'pical',
  'mulei',
  'fades',
  'jover',
  'buseu',
  'vives',
  'revol',
  'garut',
  'marza',
  'ascle',
  'anell',
  'parra',
  'torno',
  'ronda',
  'moias',
  'orrit',
  'prada',
  'ardit',
  'basco',
  'tabac',
  'guell',
  'muros',
  'naves',
  'rafel',
  'cunit',
  'guila',
  'cosco',
  'horto',
  'capas',
  'arnec',
  'orfes',
  'siuse',
  'tibel',
  'anoia',
  'carme',
  'narta',
  'arbat',
  'llora',
  'taull',
  'salos',
  'golit',
  'viern',
  'monte',
  'caliu',
  'cauba',
  'morto',
  'ainat',
  'galic',
  'broca',
  'berga',
  'boixo',
  'raons',
  'astes',
  'selva',
  'fuses',
  'fores',
  'biert',
  'boren',
  'campo',
  'caors',
  'moixi',
  'remer',
  'bonet',
  'puine',
  'artas',
  'jueus',
  'plaia',
  'casus',
  'milla',
  'agell',
  'prats',
  'brics',
  'marfa',
  'ierla',
  'gilet',
  'toses',
  'tolzo',
  'arnes',
  'gessa',
  'suert',
  'orons',
  'roger',
  'girul',
  'moror',
  'raima',
  'isaac',
  'riber',
  'matil',
  'ponts',
  'bevia',
  'camon',
  'coilh',
  'fares',
  'peira',
  'sinen',
  'virgo',
  'guena',
  'araos',
  'diana',
  'maiol',
  'torta',
  'mildi',
  'lleti',
  'naens',
  'oriol',
  'melio',
  'salou',
  'codol',
  'mollo',
  'viars',
  'plado',
  'corts',
  'illes',
  'usall',
  'sords',
  'raics',
  'sebes',
  'bensa',
  'guals',
  'mioma',
  'gospi',
  'sacal',
  'saulo',
  'safra',
  'monar',
  'rossa',
  'graus',
  'berti',
  'aiats',
  'aubet',
  'buira',
  'saura',
  'covet',
  'bello',
  'renau',
  'pauls',
  'xoros',
  'pieda',
  'senet',
  'sauri',
  'basau',
  'gelpi',
  'alies',
  'pubol',
  'aulas',
  'canet',
  'sotet',
  'senen',
  'poals',
  'cells',
  'cinca',
  'rengs',
  'cogul',
  'fiter',
  'celra',
  'nalec',
  'oreis',
  'casau',
  'clops',
  'faedo',
  'jafre',
  'adons',
  'boada',
  'boldu',
  'camps',
  'tapis',
  'tenço',
  'sagas',
  'seana',
  'espot',
  'merea',
  'roget',
  'nuria',
  'molto',
  'navel',
  'plans',
  'cabro',
  'gatet',
  'gomar',
  'bages',
  'maimo',
  'refet',
  'solso',
  'boera',
  'bruig',
  'agols',
  'trens',
  'virot',
  'albet',
  'ramio',
  'linya',
  'campa',
  'oveix',
  'nefol',
  'gebut',
  'vidra',
  'soria',
  'isona',
  'trafa',
  'benos',
  'janot',
  'viver',
  'creja',
  'ribes',
  'fiero',
  'sores',
  'alins',
  'trago',
  'erola',
  'tosca',
  'sumis',
  'bolos',
  'fraus',
  'llacs',
  'ermer',
  'coret',
  'clots',
  'cajau',
  'canti',
  'fresa',
  'rupia',
  'fites',
  'sadau',
  'corbs',
  'gavas',
  'collo',
  'giren',
  'arnan',
  'pinos',
  'viuet',
  'pimal',
  'biuse',
  'quart',
  'isola',
  'pavia',
  'soler',
  'canya',
  'seuva',
  'vilac',
  'girai',
  'aimar',
  'llaes',
  'poves',
  'tonya',
  'plaus',
  'cambo',
  'valls',
  'ocata',
  'puita',
  'fians',
  'cluet',
  'gudes',
  'xalio',
  'retou',
  'pomar',
  'piera',
  'olvan',
  'ortos',
  'clara',
  'sabra',
  'tiana',
  'serra',
  'olius',
  'dorve',
  'camos',
  'laujo',
  'llers',
  'manya',
  'quell',
  'rabos',
  'trapa',
  'veral',
  'nadal',
  'ninot',
  'tanya',
  'treno',
  'casos',
  'moron',
  'giner',
  'verdu',
  'alous',
  'sidos',
  'suria',
  'joval',
  'duran',
  'poble',
  'sarri',
  'besan',
  'conca',
  'tedui',
  'nebui',
  'liers',
  'aubas'


]
